import axios from 'axios';
import {API_BASE_URL, API_INVENTORY } from '../../helpers/urlHelper';

const API_MEDICINE_BASE = `${API_BASE_URL}${API_INVENTORY}?type=consumible`;
const API_PRODUCTS = `${API_BASE_URL}/products?type=consumible`;

export const getMedicines = async () => {
    try {
        const response = await axios.get(API_PRODUCTS);
        // La respuesta tiene la estructura: { success: true, count: 101, data: [...] }
        // Por lo tanto, devolvemos response.data.data que es el array
        return response.data.data || [];
    } catch (error) {
        console.error('Error fetching medicines:', error);
        return [];
    }
};

export const addMedicine = async (medicineData) => {
    try {
        const response = await axios.post(API_MEDICINE_BASE, medicineData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error adding medicine:', error);
        throw error;
    }
};

export const updateMedicine = async (id, medicineData) => {
    try {
        const response = await axios.put(`${API_MEDICINE_BASE}/${id}`, medicineData);
        return response.data;
    } catch (error) {
        console.error('Error updating medicine:', error);
        throw error;
    }
};

export const deleteMedicine = async (id) => {
    try {
        const response = await axios.delete(`${API_MEDICINE_BASE}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting medicine:', error);
    }
};
